/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import stopButtonStyles from '../stop-button/stop-button.styles';

import stopConfirmStyles from './stop-confirm.styles';

type PropTypes = {
    onStopConfirm: (stop: boolean) => void;
};
export const StopConfirm: FC<PropTypes> = ({ onStopConfirm }) => {
    const intl = useIntl();

    const handleConfirm = (confirm: boolean) => {
        onStopConfirm(confirm);
    };

    return (
        <div css={[stopConfirmStyles.modal]}>
            <div css={stopConfirmStyles.stopWindow}>
                <h4 css={stopConfirmStyles.stopWindowTitle}>
                    {intl.formatMessage({ id: 'sureToStop' })}
                </h4>
                <p css={stopConfirmStyles.stopWindowDescription}>
                    {intl.formatMessage({ id: 'stopConfirmationDescription' })}
                </p>
                <div css={stopConfirmStyles.stopWindowButtonContainer}>
                    <button
                        css={[
                            stopButtonStyles.powerStopButton,
                            stopConfirmStyles.stopWindowButtonNo,
                        ]}
                        onClick={() => handleConfirm(false)}>
                        {intl.formatMessage({ id: 'no' })}
                    </button>
                    <button
                        css={[
                            stopButtonStyles.powerStopButton,
                            stopConfirmStyles.stopWindowButtonYes,
                        ]}
                        onClick={() => handleConfirm(true)}>
                        {intl.formatMessage({ id: 'yes' })}
                    </button>
                </div>
            </div>
        </div>
    );
};
